import { matchPath, useLocation } from "react-router-dom";

function useResourceIdParam() {
    const { pathname } = useLocation();
    const match = matchPath<{
        vaultId?: string;
        sectionId?: string;
        groupId?: string;
        resourceId?: string;
    }>(pathname, {
        path: "/optimus/vaults/:vaultId/deepthought/sections/:sectionId/groups/:groupId/resources/:resourceId",
        exact: false,
        strict: false
    });

    const resourceId = match?.params?.resourceId;

    if (resourceId) {
        return +resourceId;
    }

    return null;
}

export default useResourceIdParam;
